export function getActiveKeys(locationPath: string): string[] {
  if (locationPath === '/') return ['/'];

  const pathSegments = locationPath.split('/').filter((segment) => !!segment);

  const keys = pathSegments.reduce<string[]>((acc, segment) => {
    const previousSegmentPath = acc[acc.length - 1];
    const segmentPath = previousSegmentPath
      ? `${previousSegmentPath}/${segment}`
      : `/${segment}`;

    acc.push(segmentPath);

    return acc;
  }, []);

  return keys;
}
export const cardColorsShop: Record<string, string> = {
  'Total Item Sold': '#7259FE',
  'Total Revenue': '#E3BB39',
  'Total Cost': '#F36363',
  'Total Profit': '#3443eb',
};
export const crossshop: Record<string, string> = {
  'T-shirt Printing': '#7259FE',
  'Medal Engraving': '#E3BB39',
  'Delivery': '#F36363',
  'Insurance':'#C59560',
  'Total Cross Sales':'#8AA624'
};
export const demographic: Record<string, string> = {
  'Nationality': '#7259FE',
  'Residence': '#E3BB39',
};
export const booth: Record<string, string> = {
  'Total Booth Count': '#7259FE',
  'Total Revenue': '#E3BB39',
};

